import { render, staticRenderFns } from "./ServiceConfigurationSection.vue?vue&type=template&id=9fe00b60&"
import script from "./ServiceConfigurationSection.vue?vue&type=script&lang=js&"
export * from "./ServiceConfigurationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports